<template>
    <transition name="slide" mode="out-in">
        <div class="register-success-tbf">
            <div class="success-modal">
                <div class="content-modal">
                    <div class="content-icon success-register">
                        <img src="/build/flappy/bird_confetti.png" />
                    </div>
                    <div class="title">{{ $t('register.register_success.title') }}</div>
                    <div class="container-content-modal">
                        <div class="container-message">
                            {{ $t('register.register_success.description') }}
                        </div>
                    </div>
                    <div class="action-form">
                        <button class="btn-tbf blue center" @click="redirect()">
                            <div class="text">{{ $t('register.register_success.button-action') }}</div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
	data(){
		return {

		}
	},
	methods: {
        redirect() {
            this.$router.push({name: 'dashboard'});
        }
	}
}
</script>